module Meevo.Components.Common {

    export class ReportRouterService implements IReportRouterService {

        constructor(protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $rootScope: angular.IRootScopeService,
            protected $q: angular.IQService) {
        }

        public routeToReport(reportKey: string, data: any) {
            return this.getReportContext(reportKey)
                .then((reportContext) => {
                    var routerData = {
                        action: "GOTO_REPORT",
                        reportContext: reportContext,
                        reportContextValues: this.mapDataToReportControls(reportKey, reportContext, data)
                    };

                    this.$rootScope.$broadcast(Messages.GOTO_STATE, { stateName: "reports", stateParams: routerData });
                });
        }

        public routeToReportWithCustomData<T>(reportKey: string, data: T): ng.IPromise<void> {
            return this.getReportContext(reportKey)
                .then((reportContext) => {
                    this.$rootScope.$broadcast(Messages.GOTO_STATE, {
                        stateName: 'reports',
                        stateParams: {
                            action: 'GOTO_REPORT',
                            reportContext: reportContext,
                            reportContextData: data
                        }
                    });
                });
        }

        public routeToReportWithData(reportKey: string, data: any): ng.IPromise<void> {
            return this.getReportContext(reportKey)
                .then((reportContext) => {
                    this.$rootScope.$broadcast(Messages.GOTO_STATE, {
                        stateName: 'reports',
                        stateParams: {
                            action: 'GOTO_REPORT',
                            reportContext: reportContext,
                            reportContextData: data.reportContextData,
                            reportContextValues: data.reportContextValues
                        }
                    });
                });
        }

        private getReportShortcutFromKey(reportKey: string) {
            var keyParts = reportKey.split(":");
            var reportShortcut: string;
            for (var i = keyParts.length - 1; i >= 0; i--) {
                if (keyParts[i] != Meevo.Components.Common.SecurityParts.KEY_PART_READ) {
                    reportShortcut = keyParts[i];
                    break;
                }
            }
            return reportShortcut;
        }

        private getReportContext(reportKey: string): ng.IPromise<any> {
            var reportShortcut: string = this.getReportShortcutFromKey(reportKey);
            return this.dataService.customMethodData(`api/Report/ReportShortCut/${reportShortcut}`, "GET", null)
                .then((response) => {
                    return response.data;
                });
        }

        private mapDataToReportControls(reportKey: string, reportContext: any, data: any): any {
            var reportControlValues = {};

            var mapper: IReportMapper = this.getReportMapper(reportKey, data);

            reportContext.controls.forEach((control: Meevo.Model.IReportControl) => {
                control.parameters.forEach((parameter) => {
                    parameter["value"] = reportControlValues[parameter.name] = mapper.getDataValue(parameter.name);
                });
            });

            if (reportKey == Meevo.Components.Common.SecurityKeys.REPORTS_INVENTORY_MI100) {
                reportContext.controls[0].parameters.push({id: null, name: 'isAllPurchaseOrdersChecked', value: data['isAllPurchaseOrdersChecked'] })
            }

            return reportControlValues;
        }

        private getReportMapper(reportKey: string, data: any): IReportMapper {
            if (reportKey == Meevo.Components.Common.SecurityKeys.REPORTS_REGISTERSALES_MR100) {
                return new TransactionEditorReportMapper(data);
            } else if (reportKey == Meevo.Components.Common.SecurityKeys.REPORTS_APPOINTMENTS_AQ025) {
                return new AQ025ReportMapper(data);
            } else if (reportKey == Meevo.Components.Common.SecurityKeys.REPORTS_INVENTORY_MI100) {
                return new MI100ReportMapper(data);
            }
            return null;
        }

        static factory(): Function {
            let svc = (dataService: Meevo.Components.BaseClasses.IDataService,
                modalService: Meevo.Components.Modal.IModalService,
                $rootScope: angular.IRootScopeService,
                $q: angular.IQService) => {
                return new ReportRouterService(dataService, modalService, $rootScope, $q);
            }

            svc.$inject = ["meevo.components.common.DataService", "meevo.components.modal.ModalService", "$rootScope", "$q"];
            return svc;
        }
    }

    export class TransactionEditorReportMapper implements IReportMapper {

        constructor(private data: any) {
        }

        public getDataValue(valueName: string): any {
            if (valueName == "OpenCloseHistoryStartDate") {
                return this.data["startDateTime"];
            }
            else if (valueName == "OpenCloseHistoryEndDate") {
                return this.data["endDateTime"];
            }
            else if (valueName == "OpenCloseHistoryStartTime") {
                return this.data["startDateTime"];
            }
            else if (valueName == "OpenCloseHistoryEndTime") {
                return this.data["endDateTime"];
            }
            else if (valueName == "ShowCompletedTransactions") {
                return this.data["includeCompleted"];
            }
            else if (valueName == "ShowVoidedTransactions") {
                return this.data["includeVoided"];
            }
            else if (valueName == "ShowRefundedTransactions") {
                return this.data["includeRefunded"];
            }
            else if (valueName == "CombineDrawerTotals") {
                return false;
            }
            else if (valueName == "ViewEditedTransactionsOnly") {
                return this.data["isEdited"];
            }
            else if (valueName == "ClientSelector_TBL") {
                return this.data["clients"];
            }
            else {
                var listItem: any;
                if (valueName == "EmployeeList_TBL") {
                    listItem = this.data["employee"];
                }
                else if (valueName == "DrawerMover_TBL") {
                    listItem = this.data["drawer"];
                }
                else if (valueName == "UserMover_TBL") {
                    listItem = this.data["createdBy"];
                }

                if (listItem) {
                    listItem.objectState = Meevo.Model.ObjectStateEnum.Active;
                    listItem.active = true;
                    listItem.selected = true;
                    return [listItem];
                }
                else {
                    return undefined;
                }
            }
        }

    }


    export class AQ025ReportMapper implements IReportMapper {

        constructor(private data: any) {
        }

        public getDataValue(valueName: string): any {
            // json params for report form
            //{
            //  "StartDate":"<Date>",
            //  "EndDate":"<Date>",
            //  "ClientPageBreak":<boolean>,
            //  "DisplayAppointmentsForClientsAtAllLocations":<boolean>,
            //  "ClientSelector_TBL":[<{Id,FirstName,LastName,DisplayName}>]
            //}
            switch (valueName) {
                case "StartDate": return this.data["startDateTime"];
                case "EndDate": return this.data["endDateTime"];
                case "ClientSelector_TBL": return this.data["clients"];
                case "ClientPageBreak": return this.data["pageBreak"];
                case "DisplayAppointmentsForClientsAtAllLocations": return this.data["apptsAllLocations"];
                default: return undefined;
            }
        }
    }


    export class MI100ReportMapper implements IReportMapper {

        constructor(private data: any) {
        }

        public getDataValue(valueName: string): any {
            // json params for report form
            // {
            //  "StartDate":"<Date>",
            //  "EndDate":"<Date>",
            //  "DistributorPOMoverList_TBL": "[<{Id,selected}>]",
            //  "PurchaseOrdersMoverList_TBL": "[<{purchaseOrderId,selected}>]"
            // }
            switch (valueName) {
                case 'PurchaseOrderStartDate':
                    return this.data['StartDate'] = this.data['dateCreated'];
                case 'PurchaseOrderEndDate':
                    return this.data['EndDate'] = this.data['dateCreated'];
                case 'DistributorPOMoverList_TBL':
                    return !!this.data['distributorId'] ? [this.data['distributorId']] : null;
                case 'PurchaseOrdersMoverList_TBL':
                    return [this.data['id']];
                default:
                    return undefined;
            }
        }
    }

    angular.module('meevo.components.common')
        .factory('meevo.components.common.ReportRouterService', ReportRouterService.factory());
}
